<template>
  <div>
    <div class="head-box">
      <h4>模板管理</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增模板</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table height="calc(100% - 50px)" :data="fpi.data" highlight-current-row>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="doEdit(scope.row)" size="mini">编辑</el-button>
              <template v-if="scope.row.state == 0">
                <el-button
                  @click.native.prevent="doEnable(scope.row._id)"
                  type="danger"
                  size="mini"
                >
                  已禁用
                </el-button>
              </template>
              <template v-else>
                <el-button
                  @click.native.prevent="doDisable(scope.row._id)"
                  type="success"
                  size="mini"
                >
                  已启用
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="新增公司" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="70px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="formData.name" suffix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="行业" prop="industry">
          <el-select v-model="formData.industry">
            <el-option
              v-for="item in options.industry"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            v-model="formData.phone"
            suffix-icon="el-icon-mobile-phone"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="ownerId">
          <el-select v-model="formData.ownerId" filterable clearable placeholder="键入名称可搜索">
            <el-option
              v-for="item in contactList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="formData.type">
            <el-option
              v-for="item in options.companytype"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="formData.description"></el-input>
        </el-form-item>
        <el-form-item label="网址" prop="website">
          <el-input v-model="formData.website" suffix-icon="el-icon-paperclip"></el-input>
        </el-form-item>
        <el-form-item label="域名" prop="domainName">
          <el-autocomplete
            v-model="formData.domainName"
            suffix-icon="el-icon-paperclip"
            :fetch-suggestions="querySearch"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="成立时间" prop="foundTime">
          <el-date-picker
            v-model="formData.foundTime"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'companys',
  data() {
    return {
      name: 'companys',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_companytype: { codeId: 'COMPANYTYPE' },
        codecfg_industry: { codeId: 'INDUSTRY' }
      },
      contactList: []
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {},
  methods: {
    formatState(row, column, cellValue, index) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatterIndustry(row, column, cellValue, index) {
      return this.osg.codelabel('industry', cellValue);
    },
    formatterType(row, column, cellValue, index) {
      return this.osg.codelabel('companytype', cellValue);
    },
    formatterOwner(row, column, cellValue, index) {
      let label = this.contactList
        .map(item => {
          if (item.value == cellValue) {
            return item.label;
          }
        })
        .join('');
      return label;
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue
      };
      //添加过滤器参数
      // $that.getParams(params);
      this.osg.ajax('basic/company/query.do', params, res => {
        this.fpi = res;
        this.getContact();
      });
    },
    getContact() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 50
      };

      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.contactList = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    doNew() {
      // this.doInit();
      // this.openDetail = true;
    },
    doEdit(row) {
      var row = this.$util.deepCopy(row);
      this.getContact();
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        this.osg.ajax('basic/company/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/company/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/company/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    }
  }
};
</script>
